import React, { useState, useRef } from 'react';
import { Image, Smile, MapPin, BarChart2, Send } from 'lucide-react';
import { getAvatarUrl } from '../../utils/helpers';
import { useToast } from '../../context/ToastContext';

const EMOJIS = ['😀','😂','❤️','🔥','👍','🎉','😍','🤔','💯','🚀','✅','😭'];

export default function CreatePost({ user, onSubmit }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const inputRef = useRef(null);
  const toast    = useToast();
  const MAX = 280;

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.length <= MAX) { setContent(val); setCharCount(val.length); }
  };

  const handleSubmit = async () => {
    if (!content.trim()) { toast.error('Write something first!'); return; }
    setLoading(true);
    try { await onSubmit(content); setContent(''); setCharCount(0); }
    catch {}
    finally { setLoading(false); }
  };

  const addEmoji = (e) => {
    setContent(p => p + e); setShowEmoji(false);
    inputRef.current?.focus();
  };

  const pct  = (charCount / MAX) * 100;
  const left = MAX - charCount;
  const circumference = 2 * Math.PI * 10;
  const strokeDashoffset = circumference - (pct / 100) * circumference;

  return (
    <div className="create-post">
      <img src={getAvatarUrl(user)} alt="" className="avatar" style={{ width:42, height:42, flexShrink:0 }}/>
      <div className="create-post-right">
        <textarea ref={inputRef} className="create-post-input"
          placeholder="What's happening?"
          value={content} onChange={handleChange} rows={2}/>

        <div className="create-post-actions">
          <div className="create-post-tools">
            <button className="post-tool-btn" title="Add photo" onClick={() => toast.info('Photo upload: connect Cloudinary or AWS S3')}>
              <Image size={18}/>
            </button>
            <div style={{ position:'relative' }}>
              <button className="post-tool-btn" title="Emoji" onClick={() => setShowEmoji(v=>!v)}>
                <Smile size={18}/>
              </button>
              {showEmoji && (
                <>
                  <div className="post-emoji-grid">
                    {EMOJIS.map(e => <button key={e} onClick={() => addEmoji(e)}>{e}</button>)}
                  </div>
                  <div style={{ position:'fixed', inset:0, zIndex:49 }} onClick={() => setShowEmoji(false)}/>
                </>
              )}
            </div>
            <button className="post-tool-btn" title="Poll" onClick={() => toast.info('Poll feature — create multi-choice polls')}>
              <BarChart2 size={18}/>
            </button>
            <button className="post-tool-btn" title="Location" onClick={() => toast.info('Location: attach your city or place')}>
              <MapPin size={18}/>
            </button>
          </div>

          <div className="create-post-right-actions">
            {charCount > 0 && (
              <div className="char-counter">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="var(--border-strong)" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="10" fill="none"
                    stroke={left < 20 ? 'var(--danger)' : left < 50 ? 'var(--accent-yellow)' : 'var(--primary)'}
                    strokeWidth="2" strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset} strokeLinecap="round"
                    transform="rotate(-90 12 12)"/>
                </svg>
                {left < 30 && <span style={{ fontSize:'0.72rem', color: left < 10 ? 'var(--danger)' : 'var(--text-muted)' }}>{left}</span>}
              </div>
            )}
            <button className="btn btn-primary btn-sm" style={{ borderRadius:'9999px', padding:'7px 18px' }}
              onClick={handleSubmit} disabled={!content.trim() || loading}>
              {loading ? <span className="loader" style={{ width:14, height:14, borderWidth:2 }}/> : <><Send size={14}/> Post</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
